import React, { Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CreateAsset from './createAsset';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Edit from '@material-ui/icons/Edit';
import ForwardIcon from '@material-ui/icons/Forward';
import PrintIcon from '@material-ui/icons/Print';
import axios from 'axios';
import * as constants from '../config/constants';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Col,Row} from 'reactstrap';
let QRCode = require('qrcode.react');

const CustomTableCell = withStyles(theme => ({
	head: {
		backgroundColor: theme.palette.grey[200],
		color: theme.palette.common.black,
		textTransform: 'uppercase',
		fontWeight: 700
	},
	body: {
		fontSize: 14,
	}
}))(TableCell);

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
	},
	table: {
		minWidth: 700,
	},
	tableCellFirst: {
		border: '2px dashed black',
		padding: '15px',
		paddingRight: '15px !important',
		textAlign: 'center',
		width: '250px !important'
	},
	assetDetails: {
		fontSize: '10px !important'
	},
	tableCell: {
		border: '2px dashed black',
		padding: '15px',
		paddingRight: '15px !important',
		textAlign: 'center'
	},
	tableCellQR: {
		width: '70px !important'
	},
	assetNameRotate: {
		display: 'none',
		width: '100px',
		transform: 'rotate(90deg) translate(-80px,-540px)',
		textTransform: 'uppercase',
		fontWeight: 700,
	},
	assetIdRotate: {
		textTransform: 'uppercase',
		fontWeight: 700,
		fontSize: '10px'
	},
	root: {
		width: '100%',
		marginTop: theme.spacing.unit * 3,
		overflowX: 'auto',
	}
});

class GenerateQR extends Component {
	constructor() {
		super();

		let url_string = window.location.href;
		let url = new URL(url_string);
		let ids = url.searchParams.get("ids");
		ids = ids.split(',');

		this.state = {
			ids: ids,
			asset: {}
		}
	}
	componentDidMount(){
		let copiedStates = Object.assign({},this.state);
		let that = this;
		axios.get(constants.API_BASE_URL + "asset/generateQR/" + this.state.ids.join(','))
		.then(function(response){
			let asset = {};
			response.data.details.map(a => {
				asset[a.id] = a;
			});
			copiedStates.asset = asset;
			that.setState(copiedStates);
		})
		.catch(function(error){
			alert(error);
		});
	}
	render = () => {
		let { classes } = this.props;
		console.log("this.state", this.state.asset);
		let qrComponents = [];
		const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		for (var i = this.state.ids.length - 1; i >= 0; i--) {
			console.log("this.state.asset", this.state.asset[this.state.ids[i]]);
			if(this.state.asset[this.state.ids[i]] !== "undefined") {
				
				let createdAt = '';
				if(this.state.asset[this.state.ids[i]]) {
					createdAt = new Date(this.state.asset[this.state.ids[i]].createdAt);
					var createdDate = months[createdAt.getMonth()];
					createdDate += ' ' + createdAt.getDate();
					createdDate += ', ' + createdAt.getFullYear();
				}
				let company = this.state.asset[this.state.ids[i]] ? this.state.asset[this.state.ids[i]].company : '';
				qrComponents.push(
					<TableRow className={classes.tableRow}>
					<TableCell className={classes.tableCellFirst}>
					<Table>
					<TableBody>
					<TableRow>
					<TableCell padding="none" className={classes.tableCellQR} style={{
						borderBottom: '0'
					}}>
					<QRCode renderAs={"svg"} size={64} value={this.state.ids[i]} />
					</TableCell>
					<TableCell padding="none" style={{
						borderBottom: '0'
					}}>
					<Typography className={classes.assetIdRotate}>{this.state.ids[i].split(":")[1] + " - " 
					+ company}</Typography>
					<Typography className={classes.assetDetails}>
					{this.state.asset[this.state.ids[i]] && createdDate}
					<br />
					{this.state.asset[this.state.ids[i]] && this.state.asset[this.state.ids[i]].name}
					</Typography>
					</TableCell>
					</TableRow>
					</TableBody>
					</Table>
					</TableCell>
					<TableCell className={classes.tableCell}>
					<QRCode renderAs={"svg"} size={128} value={this.state.ids[i]} />
					<Typography className={classes.assetDetails}>{this.state.ids[i].split(":")[1]}</Typography>
					<Typography className={classes.assetNameRotate}>{this.state.asset[this.state.ids[i]] && this.state.asset[this.state.ids[i]].name}</Typography>
					</TableCell>
					<TableCell className={classes.tableCell}>
					<QRCode renderAs={"svg"} size={64} value={this.state.ids[i]} />
					<Typography className={classes.assetDetails}>{this.state.ids[i].split(":")[1]}</Typography>
					<Typography className={classes.assetNameRotate}>{this.state.asset[this.state.ids[i]] && this.state.asset[this.state.ids[i]].name}</Typography>
					</TableCell>
					<TableCell className={classes.tableCell}>
					<QRCode renderAs={"svg"} size={32} value={this.state.ids[i]} />
					<Typography className={classes.assetDetails}>{this.state.ids[i].split(":")[1]}</Typography>
					<Typography className={classes.assetNameRotate}>{this.state.asset[this.state.ids[i]] && this.state.asset[this.state.ids[i]].name}</Typography>
					</TableCell>
					</TableRow>
					);
			}
		}
		return (
			<div>
			<div id="printArea">
			<Table>
			<TableBody>
			{qrComponents}
			</TableBody>
			</Table>
			</div>
			<Button 
			style={{
				position: 'fixed',
				bottom: '15px',
				right: '15px'
			}}
			variant="fab" color="primary" onClick={() => window.print()}>
			<PrintIcon />
			</Button>
			</div>
			);
	}
}
GenerateQR.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GenerateQR);


// WEBPACK FOOTER //
// ./src/asset/generateQR.js